<template>
    <div class="column" id="el_3254291423296121">
        <div class="row" id="el_8831666179643600">
            <div class="rowFluid">
                <div class="span12">
                    <div class="column" id="el_3472857415851407">
                        <div class="pluginWrapper plugin_7444289488428183" id="plugin_7444289488428183">
                        </div>
                        <div class="pluginWrapper plugin_6657454917995296" id="plugin_6657454917995296">
                            <div class="pluginContent"> 会员证</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" id="el_4496460810677915" v-if="member">
            <div class="rowFluid">
                <div class="span12">
                    <div class="column" id="el_3593110524362532">
                        <div class="pluginWrapper plugin_3052555938373146" id="plugin_3052555938373146">
                            <div class="pluginContent">
                                <div class="mod-list clearfix">
                                    <div class="col-lg-6 col-xm-6 col-xs-12">
                                        <div class="mod-left">
                                            <!--<img class="lazyImg" src="../assets/images/ren.png"-->
                                            <img v-if="member.pic" class="lazyImg" :src="logoUrl"
                                                 style="margin-top: 90px;margin-left: 60px;width: 80px;height: 107px;">
                                            <img v-else class="lazyImg" src="../assets/images/ren.png"
                                            style="margin-top: 90px;margin-left: 60px;width: 80px;height: 107px;">
                                        </div>
                                        <div class="mod-item" style="margin-bottom: 0px">
                                            <a class="mod-title1" >会员姓名：{{member.name}}</a>
                                            <a class="mod-title1" >会员号：{{member.code}}</a>
                                            <a class="mod-title1" >会员类别：{{member.type}}</a>
                                            <a class="mod-title1" >入会日期：<span v-if="member.approvedAt"
                                                    v-html="formatDate(member.approvedAt)"></span></a>
                                            <a class="mod-title1" >有效期：<span
                                                    v-html="formatDate(member.expiredAt)"></span></a>
                                        </div>
                                        <a class="mod-title2" >会员凭证</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import userService from '../service/user'
    import memberService from '../service/member'
    import memberFieldService from '../service/member-field'
    import config from '../config'
    import moment from '../plugins/moment'

    export default {
        name: 'User',
        data() {

            return {
                member: null,
                logoUrl:null,
                memberFields:{}
            }
        },
        created() {
            this.fetchData()
        },
        methods: {
            async fetchData() {
                const response = await userService.getUserInfo();
                if (response.data && response.data.name) {
                    const params = Object.assign({
                        name: response.data.name
                    });
                    memberService.getMemberByName(params).then((response) => {
                        this.member = response.data
                        if (this.member.pic) {
                            this.logoUrl = config.backendUrl + '/member/meeting/file/download?fileId=' + encodeURIComponent(this.member.pic);
                        }
                        let member = this.member
                        if (member) {
                            this.member = this.processExtInfo2Column(member);
                        }
                    }).catch(error => {
                        this.$message.error('加载数据出错:' + error)
                    })

                }

            },
            getMemberFields() {
                var vm = this;
                const params = Object.assign({
                    page: 0,
                    size: 10000
                });

                memberFieldService.listMemberFields(params).then((response) => {
                    if (response.data.content) {
                        this.memberFields = response.data.content;
                        this.memberFields.forEach(function (t) {
                            if (t.name == 'expired_at') {
                                t.name = 'expiredAt'
                            } else if (t.name == 'created_at') {
                                t.name = 'createdAt'
                            } else if (t.name == 'updated_at') {
                                t.name = 'updatedAt'
                            } else if (t.name == 'review_status') {
                                t.name = 'reviewStatus'
                            } else if (t.name == 'review_details') {
                                t.name = 'reviewDetails'
                            } else if (t.name == 'review_user') {
                                t.name = 'reviewUser'
                            }

                        });

                    }
                }).catch(error => {
                    this.memberFields = null;
                })


            }
            ,
            //处理动态字段 json 为字段
            processExtInfo2Column(row) {
                if (row.extInfo && row.extInfo != null && row.extInfo != '') {
                    var extInfo = JSON.parse(row.extInfo);
                    if (extInfo.length > 0) {
                        extInfo.forEach(function (t) {
                            if (t.name && t.name != null && t.name != '') {
                                row[t.name] = t.value;
                            }
                        });
                    }
                }
                return row;
            }
            ,
            //处理 动态字段为 json
            processColumn2ExtInfo(row) {
                var extInfo = [];
                for (var key in row) {
                    if (this.memberFields && this.memberFields != null && this.memberFields.length > 0) {
                        this.memberFields.forEach(function (t) {
                            if (!t.fixed && key == t.name) { //动态字段

                                var info = {};
                                info["name"] = key;
                                info["value"] = row[key];
                                extInfo.push(info);
                                delete row[key]
                            }
                        });

                    }
                }
                row.extInfo = JSON.stringify(extInfo);
                return row;
            }
            ,
            formatDate(date) {
                if (date) {
                    return moment(date,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
                }
                return ''
            },
            formatYear(date) {
                if (date) {
                    date = new Date(date);
                    let y = date.getFullYear() ;
                    return y;
                }
                return ''
            }


        }
    }
</script>
